export enum QuestionType {
  Text,
  UDAL,
  Region,
  ReadOnly,
  DropdownSingle,
  DropdownMulti,
}
